var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.SearchCombobox, {
    attrs: {
      placeholder: "Адрес",
      "data-qa": "laboratories-list-content-search",
    },
    on: {
      "search:text": _setup.searchLabList,
      "search:default": _setup.resetSearch,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }